import { render, staticRenderFns } from "./DocCollapse.vue?vue&type=template&id=e7756938&scoped=true&"
import script from "./DocCollapse.vue?vue&type=script&lang=js&"
export * from "./DocCollapse.vue?vue&type=script&lang=js&"
import style0 from "./DocCollapse.vue?vue&type=style&index=0&id=e7756938&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7756938",
  null
  
)

export default component.exports